module.exports = __webpack_public_path__ + "img/pt.ccf91f66.svg";